// @flow

export { default as DOC } from './DOC'
export { default as MP3 } from './MP3'
export { default as MP4 } from './MP4'
export { default as PDF } from './PDF'
export { default as PPT } from './PPT'
export { default as XLS } from './XLS'
export { default as ZIP } from './ZIP'
